<form (ngSubmit)="onSubmit()" [formGroup]="form" class="form">
  <form-wrapper>
    @if (!amountDriven && hasNotDisinvestment()) {
      <info [option]="optionWarning">
        Vous devez désinvestir au moins un support pour pouvoir continuer.
      </info>
    }

    @if (amountDriven) {
      @if (hasNoSupport) {
        <info [option]="optionWarning">
          Aucun support de ce contrat n'est disponible au désinvestissement. Le
          rachat programmé ne peut pas être poursuivi : vérifiez la composition
          du contrat, puis reprenez l'opération.
        </info>
      }

      @if (hasTruncatedSupports) {
        <info [option]="optionWarning">
          Seuls les supports déjà désinvestis sur ce dossier sont listés
          ci-dessous. La répartition au prorata porterait sur
          {{ listedValorisation | number: '1.2-2' }} € au lieu des
          {{ contractTotalAmount | number: '1.2-2' }} € du contrat : vérifiez la
          répartition avant de valider.
        </info>
      }

      @if (!hasNoSupport) {
        @if (exceedsListedValorisation) {
          <info [option]="optionWarning">
            Le montant du rachat ({{ rachatAmount | number: '1.2-2' }} €)
            dépasse la valorisation des supports listés ({{
              listedValorisation | number: '1.2-2'
            }}
            €). Aucune répartition n'est possible en l'état : réduisez le
            montant à l'étape précédente.
          </info>
        }

        <div class="bloc-btn-duplicate">
          <pr-button
            size="lg"
            type="button"
            display="neutral"
            label="Répartir au prorata"
            rounded
            [disabled]="exceedsListedValorisation"
            (onClick)="repartirAuProrata()"
          ></pr-button>
        </div>

        <info [option]="optionInfo">
          Chaque support est désinvesti dans la même proportion : l'allocation
          de votre contrat reste inchangée après le rachat.
        </info>
      }
    }

    @if (products.length) {
      <supports-table
        [supports]="supportsDivestment"
        [config]="supportsTable"
      ></supports-table>
    }
  </form-wrapper>
  <form-footer
    (prev)="prev()"
    (next)="onSubmit()"
    [disabledSkip]="true"
    [disabledNext]="disabledNextBtn()"
  ></form-footer>
</form>
